import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks";
import { Logo } from "../../ui/icons/logo";
import { InputComponent } from "../../ui/molecoles/input";
import { Spinner } from "../../ui/molecoles/spinner";
import { OTP, setOTPPhoneNumber, setOTPStatus, setVerifyTokenStatus, verifyToken } from "../login/slice";

export function Verify() {
    const dispatch = useAppDispatch()
    const loginState = useAppSelector(state => state.login)

    const navigation = useNavigate()

    const [otp, setOtp] = useState(false)

    useEffect(() => {
        if (loginState.loginResponse !== "")
            dispatch(verifyToken(loginState.loginResponse!))
    }, [loginState.loginResponse])

    useEffect(() => {
        if (loginState.verifyTokenStatus === "failed") {
            navigation("/login")
        }
        dispatch(setVerifyTokenStatus("idle"))
    }, [loginState.verifyTokenStatus])

    useEffect(() => {
        if (loginState.verifyTokenStatus === "successfully" && otp) {
            dispatch(OTP({ request: loginState.OTPRequest, token: loginState.loginResponse! }))
        }
    }, [loginState.verifyTokenStatus, otp])

    return (
        <div className="w-full h-screen flex justify-between items-center">
            <div className="w-[60%] h-full flex items-center justify-center">
                <img
                    src={`${process.env.PUBLIC_URL}/img/background.jpg`}
                    alt="Background"
                    className="h-full w-full object-cover rounded-tr-[40px] rounded-br-[40px]"
                />
            </div>
            <div className="w-[40%] flex items-center flex-col gap-10">
                <Logo />
                <div className="flex flex-col items-center gap-3 w-[50%]">
                    <InputComponent
                        label="Inserisci il numero di telefono da abilitare"
                        type={"text"}
                        placeholder="+3933354678932"
                        onChangeText={(value) => {
                            dispatch(setOTPPhoneNumber(value))
                        }}
                        value={loginState.OTPRequest.phoneNumber}
                        disabled={loginState.OTPStatus !== "idle"}
                    />
                </div>
                {
                    loginState.OTPStatus === "idle" ?
                        <button
                            className="h-[48px] w-[40%] rounded-[40px] py-4 bg-[#222222] text-white flex items-center justify-center"
                            onClick={() => {
                                setOtp(true)
                                dispatch(verifyToken(loginState.loginResponse!))
                            }}
                        >
                            Invia SMS
                        </button> :
                        loginState.OTPStatus === "successfully" ?
                            <div className="flex flex-row items-center gap-1">
                                <span className="text-green-500 text-text-md font-semibold">
                                    Codice inviato con successo.
                                </span>
                                <button
                                    className="underline text-black text-text-md"
                                    onClick={() => {
                                        setOtp(false)
                                        dispatch(verifyToken(loginState.loginResponse!))
                                        dispatch(setOTPStatus("idle"))
                                        dispatch(setOTPPhoneNumber(""))
                                    }}>
                                    Inviane un altro.
                                </button>
                            </div> :
                            loginState.OTPStatus === "failed" ?
                                <div className="flex flex-row items-center gap-1">
                                    <span className="text-red-500 text-text-md font-semibold">
                                        Errore durante l'invio del codice.
                                    </span>
                                    <button className="underline text-black text-text-md" onClick={() => {
                                        setOtp(false)
                                        dispatch(verifyToken(loginState.loginResponse!))
                                        dispatch(setOTPStatus("idle"))
                                        dispatch(setOTPPhoneNumber(""))
                                    }}>
                                        Riprova.
                                    </button>
                                </div> :
                                <Spinner size={24} color="neutral" />
                }
            </div>
        </div>
    )
}